export default __webpack_public_path__ + "static/media/si.5c024d1f.jpg";